import { FormFieldTypes } from "../../../../../../data/formFieldType";
export const CompanyInformationData = {
  name: "CompanyInformation",
  initialState: {
    companyName: "",
    companyUEN: "",
    typeOfCompany: null,
    mainContactPerson: null,
    mainContactPhone: '',
    mainContactEmailAddress: '',
    serviceCategory: null,
  },

  formFields: [
    {
      id: "companyName",
      lable: "Company Name",
      Field_Name: "Company Name",
      fieldType: FormFieldTypes.INPUT,
      dataField: "companyName",

      fieldSetting: {
        placeholder: "Enter Company Name",
            },

      validation: {
        required: true,
      },

      style: {
        containerCss: "col-lg-6 mb-3",
      },
    },

    {
      id: "companyUEN",
      lable: "Company UEN",
      Field_Name: "Company UEN",
      fieldType: FormFieldTypes.INPUT,
      dataField: "companyUEN",

      fieldSetting: {
        placeholder: "Enter Company UEN",
      },

      validation: {
        required: true,
      },

      style: {
        containerCss: "col-lg-6 mb-3",
      },
    },



    {
      id: "typeOfCompany",
      lable: "Type of Company",
      Field_Name: "Type of Company",
      fieldType: FormFieldTypes.SELECT,
      dataField: "typeOfCompany",

      fieldSetting: {
        placeholder: "Type of Company",

      },

      validation: {
        required: true,
      },

      style: {
        containerCss: "col-lg-6 mb-3",
      },
    },

    {
      id: "ApplicationInformation",
      lable: "",
      Field_Name: "Application Information",
      fieldType: FormFieldTypes.MAINFORMTITLE,
      dataField: "ApplicationInformation",
      fieldSetting: {
        formTitle: "Application Information",
      },
      style: {
        containerCss: "custom-grid",
      },
    },

    {
      id: "mainContactPerson",
      lable: "Main Contact Person",
      Field_Name: "Main Contact Person",
      fieldType: FormFieldTypes.SELECT,
      dataField: "mainContactPerson",

      fieldSetting: {
        placeholder: "Select",
        options: [],
      },
      style: {
        containerCss: "col-lg-6 mb-3",
      },
    },
    {
      id: "mainContactPhone",
      lable: "Main Contact Phone",
      Field_Name: "Main Contact Phone",
      fieldType: FormFieldTypes.INPUT,
      dataField: "mainContactPhone",

      fieldSetting: {
        placeholder: "",
        allowSpace: false,
      },
      style: {
        containerCss: "col-lg-6 mb-3",
      },
    },
    {
      id: "mainContactEmailAddress",
      lable: "Main Contact Email Address",
      Field_Name: "Main Contact Email Address",
      fieldType: FormFieldTypes.INPUT,
      dataField: "mainContactEmailAddress",

      fieldSetting: {
        placeholder: "",
        allowSpace: false,
      },
      style: {
        containerCss: "col-lg-6 mb-3",
      },
    },

    {
      id: "ServiceDetails",
      lable: "",
      Field_Name: "Service Details",
      fieldType: FormFieldTypes.MAINFORMTITLE,
      dataField: "ServiceDetails",
      fieldSetting: {
        formTitle: "Service Details",
      },
      style: {
        containerCss: "custom-grid",
      },
    },
   
    {
      id: "serviceCategory",
      lable: "Service Category",
      Field_Name: "serviceCategory",
      fieldType: FormFieldTypes.SELECT,

      dataField: "serviceCategory",
      fieldSetting: {
        placeholder: "Select",
        options: [],
        isSearchable: true,
      },
      validation: [{ type: "require" }],
      style: { containerCss: "col-md-4 mb-3" },
    },

     {
      id: "areYouZCP",
      label: "Are you able to offer Zero Capital Partnership (ZCP) Scheme?",
      Field_Name: "Are you able to offer Zero Capital Partnership (ZCP) Scheme?",
      fieldType: FormFieldTypes.RADIOBUTTON,
      dataField: "areYouZCP",
      fieldSetting: {
        placeholder: "",
        options: [
          { label: "Yes", value: "yes", isDisable: false },
          { label: "No", value: "no", isDisable: false, optionClass: "mr-3" },
        ],
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-12 col-12 mb-4 mt-2 x-position d-none",

      },
    },

  ],

  formSetting: {
    isViewOnly: true,
  },
};

